<template>

    <h1>404 page</h1>
    <p>Stránka nenalezena</p>

</template>
